import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { QuoteEmailAddRecFileModalPageRoutingModule } from './quote-email-add-rec-file-modal-routing.module';

import { QuoteEmailAddRecFileModalPage } from './quote-email-add-rec-file-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QuoteEmailAddRecFileModalPageRoutingModule
  ],
  declarations: [QuoteEmailAddRecFileModalPage]
})
export class QuoteEmailAddRecFileModalPageModule {}
